import { List as ChakraList } from '@chakra-ui/react';

const ListItem: React.FC<ChakraList.ItemProps> = (props) => (
  <ChakraList.Item _marker={{ color: 'inherit' }} {...props} />
);

const List = {
  Root: ChakraList.Root,
  Item: ListItem,
};

export default List;
